<span *ngIf="series.length" [matTooltip]="label" matTooltipClass="mat-tooltip-multiline">{{ latestValue }} - {{ trendLabel }}</span>
<!-- <span *ngIf="!series.length">N/A</span> -->
